import React from "react";

// Atom: Field Label. Token-styled via .smww-label; the required marker is a
// nested <span> (styled by the token layer, never a literal color here).
const FieldLabel = ({ htmlFor, required = false, children }) => (
    <label
        className="smww-label"
        htmlFor={htmlFor}
        data-atomic="atom"
        data-atomic-name="field-label"
    >
        {children} {required && <span>*</span>}
    </label>
);

export default FieldLabel;
